import TableComponent from '../../../../../../../components/stories/organisms/table'
import { TableProjectsPaginationContainer } from '../../../../../styled-component'

const CompanyProjectsTablePagination = ({ pagination, rowSelection }) => {
  if (!pagination?.totalElements) return null

  const selectedCount =
    Object.values(rowSelection ?? {}).filter(Boolean).length || null

  return (
    <TableProjectsPaginationContainer>
      <TableComponent.Pagination
        pagination={pagination}
        selectedItems={selectedCount}
      />
    </TableProjectsPaginationContainer>
  )
}

export default CompanyProjectsTablePagination
